export class CadorReference {
    key: string;
    valeur: string;
    // non utilisé dans CADOR : voir VIEW_CYBER_REFERENTIEL
    // labelCYBER: string;
    id: number;
    idParent: number;
    code: string;
}
